<template>
  <div>
    <h2 class="text-h6">Global subject</h2>
    <h3 class="h4 subtitle mb-4">Set global subject that will appear on all outgoing email.</h3>
    <div class="block">
      <p class="control">
        <c-input
          :value.sync="$v.globalSubjectText.$model"
          :lazy="false"
          class="input"
          type="text"
          placeholder="Your client subject text"
          :is-valid="checkIfValid('globalSubjectText')"
          invalid-feedback="Please enter a logo url"
          @keydown="allowSave"
        />
      </p>
    </div>

    <c-button-group>
      <c-button :disabled="!isValid" color="primary" @click="save">
        <c-spinner v-if="isSaving" color="success" size="sm" />
        <span v-else>Save subject</span>
      </c-button>
      <c-button v-if="showCancelButton" color="secondary" :disabled="isSaving" @click="cancelEdit">Cancel</c-button>
    </c-button-group>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'GlobalSubject',
  components: {},
  mixins: [validationMixin],
  props: {
    organisation: Object,
  },
  data() {
    return {
      error: null,
      isSaving: false,
      success: false,
      showCancelButton: false,
      enableSave: false,
      globalSubjectText: null,
      requiredFields: {
        globalSubjectText: false,
      },
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this, null, 4);
    },
    isValid() {
      return !this.$v.$invalid;
    },
    isDirty() {
      return this.$v.$anyDirty;
    },
  },
  mounted() {
    this.setData();
  },
  validations: {
    globalSubjectText: {
      required,
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    setData() {
      this.globalSubjectText = _.get(this.organisation, 'config.email.globalSubjectText', '');
      this.$v.$reset();
    },
    cancelEdit() {
      this.setData();
      this.resetButtonState();
    },
    resetButtonState() {
      this.showCancelButton = false;
      this.enableSave = false;
    },
    allowSave() {
      this.showCancelButton = true;
      this.enableSave = true;
    },
    save() {
      this.$v.$touch();
      if (!this.isValid) {
        return;
      }
      this.isSaving = true;
      this.error = null;
      const data = {
        id: this.organisation._id,
        globalSubjectText: this.globalSubjectText,
      };
      this.$http
        .post(buildEndpoint('organisation-admin/organisation/email/update-subject-text'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            _.set(this.organisation, 'config.email.globalSubjectText', this.globalSubjectText);
            this.resetButtonState();
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Global subject updated',
            });
            this.$v.$reset();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error updating global subject',
              message: response.data.error,
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error updating global subject',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
